import { useContext, useEffect, useState } from "react";
import { AccountTypeInitial, handleClick } from "./restaurant-accounts.utils";
import "./restaurant-accounts.styles.scss";
import { AccountsContext } from "../../../contexts/accounts.context";
import RestaurantCode from "./restaurant-code/restaurant-code.component";
const RestaurantAccounts = () => {
  const [accountTypes, setAccountTypes] = useState(AccountTypeInitial);
  const [displayValue, setDisplayValue] = useState("kitchen");
  const [displayAccounts, setDisplayAccounts] = useState({});
  const [modalClass, setModalClass] = useState("code-modal-hidden");
  const { kitAccContext, hostAccContext, deleteAccount } =
    useContext(AccountsContext);
  const handleClickModal = () => {
    if (modalClass === "code-modal-hidden") {
      setModalClass("code-modal-visible");
    } else if (modalClass === "code-modal-visible") {
      setModalClass("code-modal-hidden");
    }
  };
  useEffect(() => {
    if (displayValue === "kitchen") {
      setDisplayAccounts(kitAccContext);
    } else if (displayValue === "host") {
      setDisplayAccounts(hostAccContext);
    }
  }, [displayValue, kitAccContext, hostAccContext]);
  return (
    <div className="restaurant-accounts-container">
      <div className={modalClass}>
        <span className="code-modal-goback" onClick={handleClickModal}>
          GO BACK
        </span>
        <RestaurantCode closeFunction={handleClickModal} />
      </div>
      {window.innerWidth > 1024 ? (
        <div className="restaurant-accounts-desktop">
          <div className="restaurant-accounts-left">
            <span className="ra-left-title">Choose from the below options</span>
            <div className="ra-left-box">
              {Object.keys(accountTypes).map((index) => {
                const value = index.replace("_", " ");
                const classValue =
                  "ra-left-option-container " + accountTypes[index];
                return (
                  <div
                    key={index}
                    className={classValue}
                    onClick={() =>
                      handleClick(setDisplayValue, setAccountTypes, index)
                    }
                  >
                    <span className="ra-left-option">{value}</span>
                    <span className="ra-left-open">{">"}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="restaurant-accounts-right">
            <div className="ra-right-box">
              {Object.keys(displayAccounts).map((index) => {
                const tempObject = displayAccounts[index];
                return (
                  <div key={index} className="rest-account-container">
                    <div className="rest-account-details">
                      <span className="rest-account-name">
                        {tempObject["affiliateAccountName"]}
                      </span>
                      <span className="rest-account-lastlogin">
                        Last Login : {tempObject["lastLogin"]}
                      </span>
                      <span className="rest-account-createOn">
                        Created On : {tempObject["startDate"]}
                      </span>
                    </div>
                    <div className="rest-account-delete">
                      <span
                        className="rest-account-delete-button"
                        onClick={() => deleteAccount(tempObject["_id"])}
                      >
                        Delete
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="ra-add-container">
              <span className="ra-add-button" onClick={handleClickModal}>
                ADD NEW ACCOUNT
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="restaurant-accounts-mobile">
          <div className="restaurant-accounts-left">
            <span className="ra-left-title">Choose from the below options</span>
            <div className="ra-left-box">
              {Object.keys(accountTypes).map((index) => {
                const value = index.replace("_", " ");
                const classValue =
                  "ra-left-option-container " + accountTypes[index];
                return (
                  <div
                    key={index}
                    className={classValue}
                    onClick={() =>
                      handleClick(setDisplayValue, setAccountTypes, index)
                    }
                  >
                    <span className="ra-left-option">{value}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="restaurant-accounts-right">
            <div className="ra-right-box">
              {Object.keys(displayAccounts).map((index) => {
                const tempObject = displayAccounts[index];
                return (
                  <div key={index} className="rest-account-container">
                    <div className="rest-account-details">
                      <span className="rest-account-name">
                        {tempObject["affiliateAccountName"]}
                      </span>
                      <span className="rest-account-lastlogin">
                        Last Login : {tempObject["lastLogin"]}
                      </span>
                      <span className="rest-account-createOn">
                        Created On : {tempObject["startDate"]}
                      </span>
                    </div>
                    <div className="rest-account-delete">
                      <span
                        className="rest-account-delete-button"
                        onClick={() => deleteAccount(tempObject["_id"])}
                      >
                        Delete
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="ra-add-container">
              <span className="ra-add-button" onClick={handleClickModal}>
                ADD NEW ACCOUNT
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default RestaurantAccounts;
